import React from 'react';
import './Sidebar.css';
import { useAuth } from '../hooks/useAuth';

const Sidebar = ({ accounts, currentAccount, onAccountSelect, isMobileOpen, onMobileClose }) => {
  const { user } = useAuth();
  
  // Get account keys and sort by health score (lowest first) or name
  const accountKeys = Object.keys(accounts || {}).sort((a, b) => {
    const accountA = accounts[a];
    const accountB = accounts[b];
    if (!accountA || !accountB) return 0;
    
    // Sort by health score (lowest first to show accounts needing attention)
    if (accountA.healthScore !== accountB.healthScore) {
      return accountA.healthScore - accountB.healthScore;
    }
    // Then by name
    return accountA.name.localeCompare(accountB.name);
  });

  const handleKeyDown = (e, key) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onAccountSelect(key);
    }
  };

  const handleAccountClick = (key) => {
    onAccountSelect(key);
    if (onMobileClose) {
      onMobileClose();
    }
  };

  return (
    <aside className={`sidebar ${isMobileOpen ? 'mobile-open' : ''}`} role="navigation" aria-label="Account navigation">
      <div className="logo-container">
        <img 
          src={`${process.env.PUBLIC_URL}/Icon RELISH 1 PNG.png`} 
          alt="Logo" 
          className="logo" 
        />
        <div>
          <h1>CSM Dashboard</h1>
          <p className="subtitle">{user?.name?.split(' ')[0] || 'My'}'s Accounts</p>
        </div>
      </div>
      
      <div className="account-list">
        {accountKeys.length === 0 ? (
          <div className="no-accounts-message">
            No accounts found. Loading...
          </div>
        ) : (
          accountKeys.map(key => {
            const account = accounts[key];
            if (!account) return null;
            
            return (
              <div
                key={key}
                className={`account-item ${currentAccount === key ? 'active' : ''}`}
                onClick={() => handleAccountClick(key)}
                onKeyDown={(e) => handleKeyDown(e, key)}
                role="button"
                tabIndex={0}
                aria-label={`${account.name} - Health Score: ${account.healthScore}%`}
                aria-current={currentAccount === key ? 'true' : 'false'}
              >
                <div className="status-indicator-wrapper">
                  <div 
                    className={`status-indicator ${account.status}`}
                    aria-hidden="true"
                  ></div>
                </div>
                <div className="account-info">
                  <div className="account-name">{account.name}</div>
                  <div className="account-status">
                    <span>Health Score:</span>
                    <strong>{account.healthScore}%</strong>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </aside>
  );
};

export default Sidebar;